import { Document } from "@contentful/rich-text-types";
import { ComponentParameterEnhancerFunction } from "@uniformdev/canvas";

import { richTextToHTML } from "./utils";

export const tableDataEnhancer: ComponentParameterEnhancerFunction<
    FeatureGroup[]
> = async ({ parameter }) => {
    parameter.value?.forEach((featureGroup) => {
        featureGroup.fields.features.forEach((feature) => {
            if (
                typeof feature.fields.description === "object" &&
                feature.fields.description?.nodeType === "document"
            ) {
                feature.fields.description = richTextToHTML(
                    feature.fields.description
                );
            }
        });
    });

    return parameter.value;
};

export type FeatureGroup = {
    fields: {
        features: Array<{
            fields: {
                description: Document | string;
            };
        }>;
    };
};
